import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=1462df3f&scoped=true"
import script from "./CountryFlag.vue?vue&type=script&lang=js"
export * from "./CountryFlag.vue?vue&type=script&lang=js"
import style0 from "./CountryFlag.vue?vue&type=style&index=0&id=1462df3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1462df3f",
  null
  
)

export default component.exports